const { SYSTEM_TYPE } = require('./systemConfig')

export const basePath = ''
export const LIVE_MALL_CLUB_VALID_PATH = {
  INVITATION: 'invitation',
}

export const SHOP_VALID_PATH = {}

const VALID_PATH_DATA: any = {
  [SYSTEM_TYPE.SHOP]: SHOP_VALID_PATH,
  [SYSTEM_TYPE.LIVE_MALL_CLUB]: LIVE_MALL_CLUB_VALID_PATH,
}

export const VALID_PATH = VALID_PATH_DATA[`${process.env.SYSTEM_TYPE}`]
